import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Col, Row, Button, Input, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput, AvField } from 'availity-reactstrap-validation';
import MaterialIcon from "material-icons-react";
import i18n from "../../../../i18next";

import PaymentTypesList from './PaymentTypesList';
import OrderAmounts from './OrderAmounts';
import { convertStringToBoolean, isUserAllowedToAddBrands } from '../../../../utils/CommonUtils';
import TimeTableScreen from '../../../common/operationHours/TimeTableScreen';
import DeliveryProviderSettingsScreen from "./DeliveryProviderSettingsScreen";
import InStoreTypesSection from './InStoreTypesSection';

const INITIAL_STATE = {
    id: -1,
    preparationTimes: [],
    supportedTenderTypes: [],
    minimumOrderAmount: 1,
    maximumOrderAmount: null,
    stateAlreadyCoppiedFromProps: false,
    showErrorMsg: false,
    nextDayOrdersOnly: false,
    types: []
};

class ServiceSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: -1,
            preparationTimes: [],
            cutOffTimes: [],
            supportedTenderTypes: [],
            minimumOrderAmount: 1,
            maximumOrderAmount: null,
            stateAlreadyCoppiedFromProps: false,
            showErrorMsg: false,
            serviceNote: '',
            nextDayOrdersOnly: false,
            skipTableSelection: false,
            types: [],
            isTypesChanged: false,
            nextDayOrdersNumber: null,
            skipTableSelection: false,
            useGeneralDeliveryPartnerSettings: true
        };

        this.changeSelectedTenderTypesState = this.changeSelectedTenderTypesState.bind(this);
        this.updateSettings = this.updateSettings.bind(this);
        this.changeState = this.changeState.bind(this);
        this.updatePrepTimesState = this.updatePrepTimesState.bind(this);
        this.changeNextDayOrdersOnly = this.changeNextDayOrdersOnly.bind(this);
        this.changeTableSelection = this.changeTableSelection.bind(this);
        this.changeInStoreTypes = this.changeInStoreTypes.bind(this);
    }

    copyStateFromProps() {
        if (this.props.settings !== undefined && this.props.settings !== null &&
            this.props.settings.id !== undefined && (!this.state.stateAlreadyCoppiedFromProps || this.props.settings.id !== this.state.id)) {

            this.setState({
                id: this.props.settings.id,
                preparationTimes: this.props.settings.timeSlotBased ? this.props.settings.timeSlots : this.props.settings.preparationTimes,
                supportedTenderTypes: this.props.settings.supportedTenderTypes,
                minimumOrderAmount: this.props.settings.minimumOrderAmount,
                maximumOrderAmount: this.props.settings.maximumOrderAmount,
                stateAlreadyCoppiedFromProps: true,
                serviceNote: this.props.settings.serviceNote,
                nextDayOrdersOnly: this.props.settings.nextDayOrdersOnly,
                types: this.props.settings.types ? this.props.settings.types : [],
                nextDayOrdersNumber: this.props.settings.nextDayOrdersNumber,
                useGeneralDeliveryPartnerSettings: this.props.settings.useGeneralDeliveryPartnerSettings
            });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.prepopulatedSettings !== prevProps.prepopulatedSettings && this.props.prepopulatedSettings.length) {
            this.setState({
                ...this.state,
                preparationTimes: this.props.prepopulatedSettings,
                showErrorMsg: true
            });
        }

        if (prevProps.settings.types !== this.props.settings.types) {
            this.setState({...this.state, types: this.props.settings.types})
        }
    }

    componentWillUnmount() {
        this.setState({ INITIAL_STATE });
    }

    changeNextDayOrdersOnly({ target }) {
        if (target.name === 'nextDayOrdersOnly') {
            this.setState({ ...this.state, [target.name]: target.checked })
        } else {
            this.setState({ ...this.state, [target.name]: +target.value })
        }
    }

    changeSelectedTenderTypesState({ target }) {
        let checked = convertStringToBoolean(target.checked);
        const newTenderTypes = this.state.supportedTenderTypes.slice(0);

        if (checked == true) {
            newTenderTypes.push({
                id: target.id,
                value: target.name
            });
        } else {
            let selectedTenderTypeIndex;

            for (let i = 0; i < newTenderTypes.length; i++) {
                const currentTenderType = newTenderTypes[i];
                if (currentTenderType.id == target.id) {
                    selectedTenderTypeIndex = i;
                    break;
                }
            }
            newTenderTypes.splice(selectedTenderTypeIndex, 1);
        }

        this.setState({
            ...this.state,
            supportedTenderTypes: newTenderTypes
        });
    }

    changeState({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.value
        });
    };

    negativeIntegersValidation(e) {

        var inputKeyCode = e.keyCode ? e.keyCode : e.which;

        if (inputKeyCode != null) {
            if (inputKeyCode == 45 || inputKeyCode == 46 || inputKeyCode == 43
                || inputKeyCode == 69 || inputKeyCode == 101) {
                e.preventDefault();
            }
        }
    }

    /* Render Functions */
    renderNextDayOrdersOnly() {
        return (
            <div style={{ marginTop: 20, display: 'flex', alignItems: 'baseline' }}>
                    <Label for='nextDayOrdersOnly'>{i18n.t('common:deliveryCollectionDineInCurbside.nextDayOrdersOnly')}</Label>
                    <Input
                        type="checkbox"
                        name='nextDayOrdersOnly'
                        id='nextDayOrdersOnly'
                        style={styles.checkboxInput}
                        checked={this.state.nextDayOrdersOnly}
                        onChange={this.changeNextDayOrdersOnly}
                    />
                    <Label for='nextDayOrdersNumber' style={{margin: '0 10px 0 30px'}}>{i18n.t('common:deliveryCollectionDineInCurbside.nextDayOrdersNumber')}</Label>
                    <AvField
                        type="number"
                        min={0}
                        onKeyPress={(e) => this.negativeIntegersValidation(e)}
                        name='nextDayOrdersNumber'
                        id='nextDayOrdersNumber'
                        style={{width: 80}}
                        value={this.state.nextDayOrdersNumber}
                        onChange={this.changeNextDayOrdersOnly}
                        disabled={!this.state.nextDayOrdersOnly}
                    />
            </div>
        );
    }

    renderOperationHours() {
        const { containerStyle, headerStyle, headerTitle, paragraph } = styles;

        return (
            <Col style={containerStyle}>
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="schedule" color="#0288d1" size={20} />
                        <span style={headerTitle}>{this.props.translationPhrase}</span>
                    </div>
                </Row>
                {this.renderNextDayOrdersOnly()}
                <div style={{ marginTop: 20 }}>
                    <TimeTableScreen
                        timeSlotBased={this.props.timeSlotBased}
                        preparationTimes={this.state.preparationTimes}
                        updatePrepTimes={this.updatePrepTimesState}
                        showErrorMsg={this.state.showErrorMsg} />
                </div>
                <Row>
                    <div style={{ padding: '0 0 0 20px', width: 'calc(100% - 200px)' }}>
                        <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.timeFormat')}</p>
                        <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.nonStopWorkingTime')}</p>
                        <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.workingAfterMidnightTime')}</p>
                        <p style={paragraph}>{i18n.t('common:deliveryCollectionDineInCurbside.breakTimesAfterMidnight')}</p>
                    </div>
                </Row>
            </Col>
        );
    }

    updatePrepTimesState(prepTimes, showErrorMsg) {
        this.setState({
            ...this.state,
            preparationTimes: prepTimes,
            showErrorMsg: showErrorMsg
        });
    }

    renderInStoreTypesSection() {
        return (
            <InStoreTypesSection
                styles={styles}
                types={this.state.types}
                changeInStoreTypes={this.changeInStoreTypes}
                isTypesChanged={this.state.isTypesChanged}
                theme={this.props.theme}
                primaryColor={this.props.primaryColor}
                restaurantId={this.props.restaurantId}
                menus={this.props.settings.restaurantMenus}
                timeSlotBased={this.props.settings.timeSlotBased}
            />
        )
    }

    changeInStoreTypes(type, operationType, selectedTypeIndex) {
        let typesCopy =  [...this.state.types];
        const preparationTime = Number(type.inStorePrepTime)
       
        if(type) {
            type.inStorePrepTime = preparationTime;
        }

        if (operationType === 'create') {
            typesCopy.push(type);
        } else if (operationType === 'edit') {
            typesCopy = typesCopy.map((typeCopy, i) => {
                if (typeCopy.id === type.id && type.id) {
                    typeCopy.label = type.label;
                    typeCopy.title = type.title;
                    typeCopy.defaultMenuDraftDTO = type.defaultMenuDraftDTO;
                    typeCopy.inStorePrepTime = preparationTime;
                    typeCopy.futureOrderEnabled = type.futureOrderEnabled;
                    typeCopy.preparationTimes = type.preparationTimes;
                    typeCopy.timeSlots = type.timeSlots;
                } else if (selectedTypeIndex === i) {
                    typeCopy.label = type.label;
                    typeCopy.title = type.title;
                    typeCopy.defaultMenuDraftDTO = type.defaultMenuDraftDTO;
                    typeCopy.inStorePrepTime = preparationTime;
                    typeCopy.futureOrderEnabled = type.futureOrderEnabled;
                    typeCopy.preparationTimes = type.preparationTimes;
                    typeCopy.timeSlots = type.timeSlots;
                }
                return typeCopy;
            })
        } else if (operationType === 'delete') {
            typesCopy = typesCopy.filter((typeCopy, i) => {
                if (type.id) {
                    return typeCopy.id !== type.id
                }
                return selectedTypeIndex !== i ;
            })
        }
        this.setState({
            ...this.state,
            types: typesCopy,
            isTypesChanged: true
        });
    }

    changeTableSelection({ target }) {
        this.setState({
            ...this.state,
            [target.name]: target.checked
        });
    }

    renderPaymentTypesList() {
        return (
            <PaymentTypesList
                styles={styles}
                // isPaymentCondMet={this.props.isPaymentSettingSet && this.props.settings.length === 0}
                tenderTypes={this.props.tenderTypes}
                changeSelectedTenderTypesState={this.changeSelectedTenderTypesState}
                supportedTenderTypes={this.state.supportedTenderTypes}
            />
        );
    }

    renderOrderAmounts() {
        if (this.props.hideOrderAmounts === undefined || this.props.hideOrderAmounts === null) {
            return (
                <OrderAmounts
                    styles={styles}
                    currency={this.props.currency}
                    minimumOrderAmount={this.state.minimumOrderAmount}
                    maximumOrderAmount={this.state.maximumOrderAmount}
                    changeOrderAmountState={this.changeState}
                />
            );
        } else {
            return <div></div>;
        }
    }

    renderServiceNote() {
        const { headerStyle, headerTitle } = styles;

        return (
            <Col className="sectionStyle">
                <Row>
                    <div style={headerStyle}>
                        <MaterialIcon icon="speaker_notes" size={20} color='#0288d1' />
                        <span style={headerTitle}>{i18n.t('screens:restaurantsMainContainer.serviceNotes')}</span>
                    </div>
                </Row>
                <Row>
                    <AvGroup row style={{ width: '100%', marginTop: 10 }}>
                        <AvInput style={{ width: 'calc(83% - 10px)', marginLeft: 20, height: 100, resize: 'none' }}
                            type="textarea" name="serviceNote" placeholder={i18n.t('screens:restaurantsMainContainer.serviceNotesPlaceholder')}
                            value={this.state.serviceNote}
                            onChange={this.changeState}
                        />
                    </AvGroup>
                </Row>
            </Col>
        );
    }


    renderSaveButton() {
        const { saveButton, spaceBetween } = styles;

        return (
            <Row>
                <Col>
                    <Button color="primary" form="serviceSettingsForm" sm={12} style={saveButton}>
                        <MaterialIcon icon="save" color="#fff" size={18} /><span style={spaceBetween}>{i18n.t('common:buttons.save')}</span>
                    </Button>
                </Col>
            </Row>
        );
    }

    updateSettings() {
        const settings = {
            id: this.state.id,
            preparationTimes: this.state.preparationTimes,
            supportedTenderTypes: this.state.supportedTenderTypes,
            minimumOrderAmount: this.state.minimumOrderAmount,
            maximumOrderAmount: this.state.maximumOrderAmount,
            serviceNote: this.state.serviceNote,
            nextDayOrdersOnly: this.state.nextDayOrdersOnly,
            nextDayOrdersNumber: this.state.nextDayOrdersNumber,
            useGeneralDeliveryPartnerSettings: this.state.useGeneralDeliveryPartnerSettings
        };

        if (this.props.isInStore) {
            settings.skipTableSelection = this.state.skipTableSelection;
            settings.types = this.state.types;
        }

        this.props.updateSettings(settings, () => {
            this.setState({
                ...this.state,
                showErrorMsg: false,
                isTypesChanged: false
            });

            if (this.props.showDeliveryProviderScreen) {
                this.child.saveDeliveryPartnerSettings();
            }
        });
    }

    render() {
        const { containerMargin, formStyle } = styles;
        const isUserIsAdminOrMasterAdmin = isUserAllowedToAddBrands(this.props.currentlyLoggedInUser)
        this.copyStateFromProps();

        return (
            <Container fluid style={containerMargin}>
                <AvForm id="serviceSettingsForm" onValidSubmit={this.updateSettings} style={formStyle}>
                    {this.props.isInStore ? this.renderInStoreTypesSection() : this.renderOperationHours()}
                    {this.renderPaymentTypesList()}
                    {this.renderOrderAmounts()}
                    {this.renderServiceNote()}
                    {/* {this.renderSaveButton()} OLD BUTTON */}
                </AvForm>
                {this.props.showDeliveryProviderScreen && isUserIsAdminOrMasterAdmin ?
                    <DeliveryProviderSettingsScreen 
                    onRef={ref => (this.child = ref)} 
                    onChangePartnerCheckbox={this.changeTableSelection}
                    partnerCheckboxValue={this.state.useGeneralDeliveryPartnerSettings}
                    />
                    : null}
                {this.renderSaveButton()}
            </Container>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        currentlyLoggedInUser: state.user
    }
}

export default connect(mapStateToProps)(ServiceSettings);

const styles = {
    testBorder: {
        border: '1px solid red'
    },
    formStyle: {
        width: '100.5%'
    },
    containerMargin: {
        marginLeft: 0
    },
    containerStyle: {
        paddingLeft: 30,
        marginBottom: 25,
        paddingBottom: 15,
        backgroundColor: '#fafafa',
        borderLeft: '1px solid #0288d1',
        paddingTop: 10
    },
    headerStyle: {
        paddingLeft: 0,
        paddingRight: 0,
        borderBottom: "1px solid rgb(222, 226, 230)",
        width: 299
    },
    spaceBetween: {
        paddingLeft: 4
    },
    headerTitle: {
        paddingLeft: 4,
        color: '#0288d1'
    },
    rowStyler: {
        marginTop: 20,
        marginLeft: 15
    },
    zeroPadding: {
        paddingLeft: 0
    },
    posAsyncTimeInput: {
        width: 80,
        float: 'left',
        marginRight: 5
    },
    paragraph: {
        fontSize: 14,
        display: "flex",
        justifyContent: 'flex-end',
        marginBottom: 5
    },
    checkboxInput: {
        position: "relative",
        marginLeft: 10
    },
    columnGroup: {
        display: 'flex',
        justifyContent: "space-between",
        paddingLeft: 0
    },
    saveButton: {
        float: 'right',
        marginTop: 10,
        marginBottom: 10
    },
    labelPadding: {
        paddingTop: 10,
        paddingRight: 20
    },
    orderAmountAvGroup: {
        display: 'flex',
        marginRight: 30
    },
    currencyTypeStyle: {
        alignSelf: 'center',
        paddingRight: 10,
        paddingLeft: 5,
        width: 50
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/settings/service/ServiceSettings.js